<template>
  <div class="v-carousel">
    <b-carousel :id="id" :interval="4000" controls>
      <div v-for="bn in banner.list">
        <b-carousel-slide :img-src="bn.banner"></b-carousel-slide>
      </div>
    </b-carousel>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  props: ["id", "width", "height"],
  components: { BCarousel, BCarouselSlide },
  computed: {
    ...mapState({
      banner: state => state.banner
    })
  },
  async created() {
    await this.$store.dispatch("banner/getList", {
      width: this.width,
      height: this.height
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/banners/src/BannerCarousel.vue